import { render } from "./StatsBuilderRow.vue?vue&type=template&id=6a1bf248&scoped=true"
import script from "./StatsBuilderRow.vue?vue&type=script&lang=ts"
export * from "./StatsBuilderRow.vue?vue&type=script&lang=ts"

import "./StatsBuilderRow.vue?vue&type=style&index=0&id=6a1bf248&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6a1bf248"

export default script